import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import getConfig from 'next/config';
import axios from 'axios';
import { GooglePlacesAutoComplete } from '@custom-components';
import { debounce } from 'lodash';

const {
  publicRuntimeConfig: { GOOGLE_MAPS_API_KEY }
} = getConfig();

const GOOGLE_API_BASE_URL = 'https://maps.googleapis.com/maps/api';
const GEOCODE_URL = `${GOOGLE_API_BASE_URL}/geocode/json`;

function GoogleSearch(props) {
  const { name, label, placeholder, variant, setFieldValue, createToast, value, styledProps } = props;

  const [options, setOptions] = useState([]);
  const [googleLoading, setGoogleLoading] = useState(false);

  const handleInputChange = (query) => {
    if (!query?.length || query.length < 3) {
      setOptions([]);
      return;
    }
    setGoogleLoading(true);

    try {
      const google = window?.google;
      const service = new google.maps.places.AutocompleteService();
      service.getPlacePredictions({ input: query }, (predictions) => {
        setOptions(predictions);
        setGoogleLoading(false);
      });
    } catch (error) {
      createToast(
        'There was an error fetching data from Google Places API. Please use the Property field to specify a valid LodgeLink property.',
        { variant: 'error' }
      );
      setGoogleLoading(false);
    }
  };

  const handleItemClick = async (query) => {
    await axios
      .get(GEOCODE_URL, {
        params: {
          key: GOOGLE_MAPS_API_KEY,
          address: query
        }
      })
      .then((response) => {
        const { geometry } = response?.data?.results[0] || {};
        const { lat, lng } = geometry.location;

        setFieldValue(name, query);
        setFieldValue('lat', lat);
        setFieldValue('lng', lng);
      })
      .catch(() => {
        createToast('Error fetching address', { variant: 'error' });
      });
  };

  return (
    <GooglePlacesAutoComplete
      name={name}
      label={label}
      placeholder={placeholder}
      variant={variant}
      loading={googleLoading}
      value={value}
      onInputChange={debounce(handleInputChange, 300)}
      suggestions={options}
      filterProps={['description']}
      onClickItem={handleItemClick}
      styledProps={styledProps}
    />
  );
}

GoogleSearch.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.string,
  placeholder: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  createToast: PropTypes.func.isRequired,
  styledProps: PropTypes.shape({})
};
GoogleSearch.defaultProps = {
  value: PropTypes.string,
  name: 'location',
  label: 'Location',
  variant: 'outlined',
  placeholder: 'Search by Property, Location, Address, Point of Interest, ...',
  styledProps: {}
};

export default GoogleSearch;
